import { createSelector } from '@reduxjs/toolkit';
import { setSiteName } from 'utils/helper/site';
import isEmpty from 'lodash/isEmpty';

const globalOptionStateSelector = state => state.globalList;

export const getGlobalSiteList = createSelector(
  state => state.globalOptions,
  globalOptions => {
    // get the site list
    return globalOptions.sites?.list ? globalOptions.sites?.list : [];
  },
);

export const getGlobalDepartmentRecords = createSelector(
  globalOptionStateSelector,
  globalOptions => {
    return globalOptions.departments.record;
  },
);

export const areGlobalDepartmentRecordsEmpty = createSelector(
  globalOptionStateSelector,
  globalOptions => {
    return !isEmpty(globalOptions.departments.record);
  },
);
export const getGlobalUserRecords = createSelector(
  globalOptionStateSelector,
  globalOptions => {
    return globalOptions.users.record;
  },
);
/**
 *TODO: This folder shall be removed in future and put in globalModules
 */
export const getSiteListOptions = createSelector(
  state => state.globalOptions,
  state => state.businessClients.dataGridTable.list,
  (globalOptionObject, businessClientList) => {
    return globalOptionObject.sites?.list.map(site => ({
      ...site,
      id: site.id,
      name: setSiteName(site, businessClientList),
      assignedDepartmentList: site.assignedDepartmentList,
    }));
  },
);
